import React from 'react';
import { ILxsQuickActionsData } from './lxs-quick-actions.data';
import { ILxsQuickActionsProps } from './lxs-quick-actions.props.autogenerated';
import LxsQuickActionsView from './lxs-quick-actions.view';

const LxsQuickActions: React.FC<ILxsQuickActionsProps<ILxsQuickActionsData>> = props => {
    const handleHeadingEdit = (actionIndex: number, value: string) => {
        const action = props.config.actions?.[actionIndex];

        if (action?.heading) {
            action.heading.text = value;
        }
    };

    const handleDescriptionEdit = (actionIndex: number, value: string) => {
        const action = props.config.actions?.[actionIndex];

        if (action) {
            action.description = value;
        }
    };

    return (
        <LxsQuickActionsView
            config={props.config}
            requestContext={props.context.request}
            onHeadingEdit={handleHeadingEdit}
            onDescriptionEdit={handleDescriptionEdit}
        />
    );
};

export default LxsQuickActions;
